import React, { Component } from "react";
import moment from "moment";
import { 
    Col,
    Row 
} from "react-bootstrap";
import { formatPrice } from "helpers/functions/pricing";

class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        const {
            data
        } = this.props;
        
        return (
            <div className="payroll-report">
                <div className="top-info">
                    <div className="employee-name">
                        <h3>{data.employeeName || 'N/A'}</h3>
                    </div>
                    <div className="dates">
                        <div className="date">
                            <span className="category">Start Date</span>
                            <p>{moment(data.startDate).format("MM/DD/YYYY") || 'N/A'}</p>
                        </div>
                        <div className="date">
                            <span className="category">End Date</span>
                            <p>{moment(data.endDate).format("MM/DD/YYYY") || 'N/A'}</p>
                        </div>
                    </div>
                </div>
                <div className="info-content">
                    <Row>
                        <Col sm={4}>
                        <div>
                            <span className="category">Monthly Wage</span>
                            <p>{formatPrice(data.monthlyWage) || 'N/A'}</p>
                        </div>
                        <div>
                            <span className="category">Period Wage</span>
                            <p>{formatPrice(data.periodWage) || 'N/A'}</p>
                        </div>
                        </Col>
                        <Col sm={4}>
                        <div>
                            <span className="category">Net Monthly Wage</span>
                            <p>{formatPrice(data.netMonthlyWage) || 'N/A'}</p>
                        </div>
                        <div>
                            <span className="category">Net Period Wage</span>
                            <p>{formatPrice(data.netPeriodWage) || 'N/A'}</p>
                        </div>
                        </Col>
                    </Row>
                    <Row className="section">
                        <h3 className="row-title">Government Deductions</h3>
                        <Col sm={3}>
                        <div>
                            <span className="category">Income Tax Deduction</span>
                            <p>{data.governmentDeductions && data.governmentDeductions.incomeTaxDeduction ? formatPrice(data.governmentDeductions.incomeTaxDeduction) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">SSS Deduction</span>
                            <p>{data.governmentDeductions && data.governmentDeductions.sssDeduction ? formatPrice(data.governmentDeductions.sssDeduction) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">PHIC Deduction</span>
                            <p>{data.governmentDeductions && data.governmentDeductions.phicDeduction ? formatPrice(data.governmentDeductions.phicDeduction) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">Pag-Ibig Deduction</span>
                            <p>{data.governmentDeductions && data.governmentDeductions.pagIbigDeduction ? formatPrice(data.governmentDeductions.pagIbigDeduction) : 0.00}</p>
                        </div>
                        </Col>
                    </Row>
                    <Row className="section">
                        <h3 className="row-title">Schedule Adjustments</h3>
                        <Col sm={3}>
                        <div>
                            <span className="category">Late Deduction</span>
                            <p>{data.scheduleAdjustments && data.scheduleAdjustments.lateDeduction ? formatPrice(data.scheduleAdjustments.lateDeduction) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Undertime Deduction</span>
                            <p>{data.scheduleAdjustments && data.scheduleAdjustments.undertimeDeduction ? formatPrice(data.scheduleAdjustments.undertimeDeduction) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">Absent Deduction</span>
                            <p>{data.scheduleAdjustments && data.scheduleAdjustments.absentDeduction ? formatPrice(data.scheduleAdjustments.absentDeduction) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">OT Addition</span>
                            <p>{data.scheduleAdjustments && data.scheduleAdjustments.otAddition ? formatPrice(data.scheduleAdjustments.otAddition) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">Holiday Addition</span>
                            <p>{data.scheduleAdjustments && data.scheduleAdjustments.holidayAddition ? formatPrice(data.scheduleAdjustments.holidayAddition) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Rest day Addition</span>
                            <p>{data.scheduleAdjustments && data.scheduleAdjustments.restdayAddition ? formatPrice(data.scheduleAdjustments.restdayAddition) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">Night Shift Addition</span>
                            <p>{data.scheduleAdjustments && data.scheduleAdjustments.nightShiftAddition ? formatPrice(data.scheduleAdjustments.nightShiftAddition) : 0.00}</p>
                        </div>
                        </Col>
                    </Row>

                    <Row className="section">
                        <h3 className="row-title">Other Adjustments</h3>
                        <Col sm={3}>
                        <div>
                            <span className="category">Longevity Addition</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.longevityAddition ? formatPrice(data.otherAdjustments.longevityAddition) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Merit Addition</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.meritAddition ? formatPrice(data.otherAdjustments.meritAddition) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Allowances Addition</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.allowancesAddition ? formatPrice(data.otherAdjustments.allowancesAddition) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">Other Income Addition</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.otherIncomeAddition ? formatPrice(data.otherAdjustments.otherIncomeAddition) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Coop Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.coopDeduction ? formatPrice(data.otherAdjustments.coopDeduction) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Custom Values Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.customValues ? formatPrice(data.otherAdjustments.customValues) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">Employee Vale Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.employeeValeDeduction ? formatPrice(data.otherAdjustments.employeeValeDeduction) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Utility Bill Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.utilityBillDeduction ? formatPrice(data.otherAdjustments.utilityBillDeduction) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Government Loans Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.governmentLoans ? formatPrice(data.otherAdjustments.governmentLoans) : 0.00}</p>
                        </div>
                        </Col>
                        <Col sm={3}>
                        <div>
                            <span className="category">Educational Loan Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.educationalLoanDeduction ? formatPrice(data.otherAdjustments.educationalLoanDeduction) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Uniform Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.uniformDeduction ? formatPrice(data.otherAdjustments.uniformDeduction) : 0.00}</p>
                        </div>
                        <div>
                            <span className="category">Other Deduction</span>
                            <p>{data.otherAdjustments && data.otherAdjustments.otherDeduction ? formatPrice(data.otherAdjustments.otherDeduction) : 0.00}</p>
                        </div>
                        
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default Reports;
